import { useTranslation } from 'react-i18next';
import { iconArrowRightHeaderCourses } from '../../assets';
import { useTheme } from '../../theme';

export interface CreateCourseStepPaginationProps {
  currentStep: number;
  totalSteps: number;
  onPreviousStep: () => void;
  onNextStep: () => void;
  /** Quando true, desabilita o botão "Next Step" (ex.: durante envio no step 1). */
  nextStepDisabled?: boolean;
}

export function CreateCourseStepPagination({
  currentStep,
  totalSteps,
  onPreviousStep,
  onNextStep,
  nextStepDisabled = false,
}: CreateCourseStepPaginationProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing.md,
        marginTop: theme.spacing.xl,
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius.sm,
      }}
    >
      <button
        type="button"
        onClick={onPreviousStep}
        disabled={currentStep <= 1}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          padding: `${theme.spacing.sm} ${theme.spacing.md}`,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize.sm,
          fontWeight: theme.typography.fontWeight.medium,
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.paper,
          border: `${theme.shape.borderWidth.thin} solid ${theme.palette.border.main}`,
          borderRadius: theme.shape.borderRadius.sm,
          cursor: currentStep <= 1 ? 'not-allowed' : 'pointer',
          opacity: currentStep <= 1 ? 0.7 : 1,
        }}
      >
        {t('courses.create.previous_step')}
      </button>
      <span
        style={{
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize.sm,
          color: theme.palette.text.secondary,
        }}
      >
        {t('courses.create.step_of', {
          current: currentStep,
          total: totalSteps,
        })}
      </span>
      <button
        type="button"
        onClick={onNextStep}
        disabled={currentStep >= totalSteps || nextStepDisabled}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: theme.spacing.sm,
          padding: `${theme.spacing.sm} ${theme.spacing.md}`,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize.sm,
          fontWeight: theme.typography.fontWeight.medium,
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
          border: 'none',
          borderRadius: theme.shape.borderRadius.sm,
          cursor:
            currentStep >= totalSteps || nextStepDisabled
              ? 'not-allowed'
              : 'pointer',
          opacity: currentStep >= totalSteps || nextStepDisabled ? 0.7 : 1,
        }}
      >
        {t('courses.create.next_step')}
        <img
          src={iconArrowRightHeaderCourses}
          alt=""
          width={18}
          height={18}
          aria-hidden
          style={{ display: 'block' }}
        />
      </button>
    </div>
  );
}
